import { defaultHowItWorks } from 'artkive/stores/ecom/constants/data'

import Customer from 'images/ecom/virtual-gallery/CustomerAvatar.png'
import Process4 from 'images/ecom/virtual-gallery/Process4.png'

export const virtualGalleryBullets = [
  { text: 'Displays up to 100 pieces of artwork' },
  { text: 'Easily shareable mp4 video' },
  { text: 'Professional editing of each piece of art and gallery curation' },
]

export const testimonialUser = {
  address: 'Sherman Oaks, CA',
  name: 'Tess',
  src: Customer,
}

export const howItWorksSteps = [
  ...defaultHowItWorks.slice(0, 3),
  {
    image: Process4,
    title: 'Design & Enjoy',
    body: 'Along with your Kids Art Book, our team will thoughtfully design your Virtual Gallery, ready to be viewed on all your devices.',
  },
]

export const imageBgPosition = {
  xs: '50% 25%',
  sm: '50% 25%',
}
